module.exports = __webpack_public_path__ + "static/media/PRISM_8220.466fd2e3.jpg";